import React from 'react';
import { motion } from 'framer-motion';
import { Check, CreditCard, ShieldCheck } from 'lucide-react';
export function OfferSection() {
  const plans = [{
    name: 'SUPER COMBO PRO',
    subtitle: 'El sistema base para transformar tu taller.',
    oldPrice: '$276.000',
    price: '$19.990',
    borderColor: 'border-[#1B3A5C]',
    btnClass: 'bg-[#1B3A5C] hover:bg-[#152c46] text-white',
    btnText: '🔥 QUIERO ESTE PLAN →',
    link: 'https://solucionstore.shop/cart/45494138568895:1',
    badge: null,
    checkColor: 'text-[#1B3A5C]',
    nameColor: 'text-white',
    items: ['6 Tomos Técnicos', '6 Bonos Exclusivos', 'Acceso PDF inmediato', 'Garantía 7 días']
  }, {
    name: 'COMBO + INGENIERÍA PRO',
    subtitle: 'Para calcular y diseñar como ingeniero.',
    oldPrice: '$430.000',
    price: '$27.990',
    borderColor: 'border-[#D4A017]',
    btnClass: 'bg-[#D4A017] hover:bg-[#b58812] text-black font-black shadow-[0_0_20px_rgba(212,160,23,0.3)]',
    btnText: '⭐ QUIERO ESTE PLAN →',
    link: 'https://solucionstore.shop/cart/45494160785599:1',
    badge: '⭐ MÁS POPULAR',
    checkColor: 'text-[#D4A017]',
    nameColor: 'text-[#D4A017]',
    items: ['Todo lo del plan base', 'Master-Calc Automatizada', 'Sistema de Diseño Pro', 'Soporte WhatsApp 30 días', 'Certificado + Actualizaciones']
  }, {
    name: 'ECOSISTEMA TOTAL',
    subtitle: 'Para abrir un segundo negocio en tu taller.',
    oldPrice: '$583.000',
    price: '$35.990',
    borderColor: 'border-purple-500',
    btnClass: 'bg-purple-600 hover:bg-purple-700 text-white font-black shadow-[0_0_20px_rgba(147,51,234,0.3)]',
    btnText: '💎 QUIERO EL PACK MAESTRO →',
    link: 'https://solucionstore.shop/cart/45525326495935:1',
    badge: '💎 PACK MAESTRO',
    checkColor: 'text-purple-400',
    nameColor: 'text-purple-400',
    items: ['Todo lo del plan anterior', 'Master-Guide Muebles (60 págs)', 'Bajo mesadas y alacenas', 'Sillones y mesas exterior', 'Mamparas y barandas', '3 Planos de Despiece', 'Precios de venta sugeridos']
  }];
  return <section id="oferta" className="bg-[#0A0A0A] py-14 px-4 scroll-mt-10" data-id="element-158">
      <div className="container mx-auto max-w-7xl" data-id="element-159">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="text-center mb-6" data-id="element-160">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-2" data-id="element-161">
            Elegí tu plan hoy
          </h2>
          <p className="text-[#D4A017] text-lg font-medium" data-id="element-162">
            Tres niveles. Un solo objetivo: que tu taller genere más plata.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5 max-w-6xl mx-auto mb-8" data-id="element-163">
          {plans.map((plan, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: idx * 0.1
        }} className={`bg-[#111111] border-2 ${plan.borderColor} rounded-2xl p-4 md:p-5 flex flex-col relative ${idx === 1 ? 'md:-translate-y-2 shadow-[0_0_30px_rgba(212,160,23,0.15)]' : idx === 2 ? 'shadow-[0_0_20px_rgba(147,51,234,0.1)]' : ''}`} data-id="element-164">
              {plan.badge && <div className={`absolute -top-3 left-1/2 transform -translate-x-1/2 ${idx === 1 ? 'bg-[#D4A017] text-black' : 'bg-purple-600 text-white'} font-bold px-3 py-0.5 rounded-full text-xs tracking-wider whitespace-nowrap`} data-id="element-165">
                  {plan.badge}
                </div>}

              <h3 className={`text-lg font-bold ${plan.nameColor} mb-0.5 mt-1`} data-id="element-166">
                {plan.name}
              </h3>
              <p className="text-gray-400 text-xs mb-3" data-id="element-167">{plan.subtitle}</p>

              <div className="mb-3" data-id="element-168">
                <span className="text-gray-500 line-through text-xs" data-id="element-169">
                  {plan.oldPrice}
                </span>
                <div className="flex items-baseline gap-1" data-id="element-170">
                  <span className="text-3xl font-black text-white" data-id="element-171">
                    {plan.price}
                  </span>
                  <span className="text-gray-400 text-xs" data-id="element-172">ARS</span>
                </div>
              </div>

              <ul className="space-y-1.5 mb-4 text-sm flex-grow" data-id="element-173">
                {plan.items.map((item, i) => <li key={i} className="flex items-start gap-2 text-gray-300" data-id="element-174">
                    <Check className={`w-4 h-4 ${plan.checkColor} shrink-0 mt-0.5`} data-id="element-175" />
                    <span data-id="element-176">{item}</span>
                  </li>)}
              </ul>

              <div className="mt-auto" data-id="element-177">
                <a href={plan.link} className={`w-full ${plan.btnClass} font-bold text-sm py-3 px-4 rounded-xl text-center transition-all transform hover:scale-105 mb-1.5 block`} data-id="element-178">
                  {plan.btnText}
                </a>
                <p className="text-center text-xs text-gray-400" data-id="element-179">
                  💳 3 cuotas fijas
                </p>
              </div>
            </motion.div>)}
        </div>

        {/* Social proof + Payment */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="text-center" data-id="element-180">
          <p className="text-[#D4A017] text-sm md:text-base italic font-medium max-w-2xl mx-auto mb-6" data-id="element-181">
            "El 68% de los carpinteros que llegan hasta acá eligen el plan de
            $35.990. Porque entienden que es la única vez que van a poder
            acceder a este precio."
          </p>

          <div className="flex justify-center items-center gap-4 text-gray-400 font-medium text-sm mb-2" data-id="element-182">
            <span data-id="element-183">Mercado Pago</span>
            <span data-id="element-184">•</span>
            <span data-id="element-185">Visa</span>
            <span data-id="element-186">•</span>
            <span data-id="element-187">Mastercard</span>
            <span data-id="element-188">•</span>
            <span data-id="element-189">Amex</span>
          </div>
          <div className="flex justify-center items-center gap-3 text-gray-500 text-xs" data-id="element-190">
            <span className="flex items-center gap-1" data-id="element-191">
              <CreditCard className="w-3 h-3" data-id="element-192" /> 3 cuotas fijas
            </span>
            <span className="flex items-center gap-1" data-id="element-193">
              <ShieldCheck className="w-3 h-3" data-id="element-194" /> Pago 100% seguro
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}